import { Grid, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { TabPanel } from 'src/components/shared/Tabs/TabPanel';
import { ProductDetailDto } from 'src/store/products/product';
import { CrystalLabel } from './Crystal/CrystalLabel';
import { ProductSampleLabel } from './ProductSample/ProductSampleLabel';
import { StandardLabel } from './Standard/StandardLabel';

type Props = {
  product: ProductDetailDto;
};

export type LabelType = 'STANDARD' | 'CRYSTAL' | 'PRODUCT_SAMPLE';

export const LabelsContainer: React.FC<Props> = ({ product }) => {
  const [tab, setTab] = useState<number>(0);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Tabs
          value={tab}
          onChange={(_, tab) => setTab(tab)}
          variant="fullWidth"
          aria-label="Product tabs"
        >
          <Tab label="Standard" />
          <Tab label="Crystal" />
          <Tab label="Product Sample" />
        </Tabs>

        <TabPanel index={0} value={tab} className="p-32">
          <StandardLabel product={product} />
        </TabPanel>
        <TabPanel index={1} value={tab} className="p-32">
          <CrystalLabel product={product} />
        </TabPanel>
        <TabPanel index={2} value={tab} className="p-32">
          <ProductSampleLabel product={product} />
        </TabPanel>
      </Grid>
    </Grid>
  );
};
